export const comites = [
    {
        title: "Comité de rédaction",
        description: "Il constitue l'équipe qui assure le fonctionnement de la revue.",
        members: [
            { name: "Olivier Pissoat", affiliation: "CNRS UMR Passages" },
            { name: "Jane Cooper", affiliation: "Nantes Université - CNRS" },
            { name: "Brooklyn Simmons", affiliation: "CNRS - UAR MESAG" },
            { name: "Guy Hawkins", affiliation: "Université de Bretagne Occidentale-CNRS" },
            { name: "Jacob Jones", affiliation: "Université de Bretagne Occidentale-CNRS" },
            { name: "Darrell Steward", affiliation: "Université de Bretagne Occidentale-CNRS" }
        ],
        titleColor: "text-greenlogo"
    },
    {
        "title": "Le comité scientifique",
        "description": "Il est constitué de personnalités issus du monde de la recherche, dont les objets et thématiques scientifiques recoupent ceux de Madatlas. Le comité scientifique est le garant de la rigueur scientifique des contenus présentés dans les articles, auxquels ses membres peuvent contribuer à l’évaluation à la demande du comité de rédaction. Il émet des avis et recommandations en matière de stratégie éditoriale." +
            "Son rôle est également de faire connaître la revue au sein de ses réseaux nationaux et internationaux." +
            "\n\nIl est composé de :",
        "members": [
            { "name": "Bessie Cooper", "affiliation": "Nantes Université - IGARUN" },
            { "name": "Courtney Henry", "affiliation": "Nantes Université - CNRS" },
            { "name": "Kathryn Murphy", "affiliation": "CNRS - UAR MESAG" },
            { "name": "Devon Lane", "affiliation": "Université de Bretagne Occidentale-CNRS" },
            { "name": "Eleanor Pena", "affiliation": "Université de Bretagne Occidentale-CNRS" },
            { "name": "Arlene McCoy", "affiliation": "Université de Bretagne Occidentale-CNRS" }
        ],
        "titleColor": "text-greenlogo"
    }
];

export const secretariatInfo = {
    description: "Le secrétariat de rédaction est assuré par, Tefy (Université de Fianarantsoa), Felana (Université de Fianarantsoa) et Anouk Agrech (Université Bordeaux Montaigne). Il assure le lien avec les autrices et auteurs et la mise en ligne des articles.",
    titleColor: "text-greenlogo"
};